import useGrpc from "./grpc";
import { escapeHtml } from "./app.js";
import useAuth from "./firebase";
import { showSpinner, hideSpinner } from "./fullscreenSpinner";

let auth = useAuth();
console.log(auth.getCurrentUser());
const grpc = useGrpc();
let student = [];
let school = [];
let today = [];
let schoolStudent = [];
let showMoreToday = false;
let showMoreStudent = false;
let showMoreMySchool = false;
let studentlbFinished = false;
let schoollbFinished = false;
let todaylbFinished = false;
let myschoollbFinished = false;

// tbody is read only in internet explorer so create a new table and copy its tbody
function setTBodyInnerHTML(tbody, html) {
  if (typeof tbody === "undefined" || tbody == null || html === "") {
    return null;
  }

  const temp = tbody.ownerDocument.createElement("div");
  temp.innerHTML = "<table>" + html + "</table>";
  tbody.parentNode.replaceChild(temp.firstChild.firstChild, tbody);
}

// function titleCase(str) {
//   let splitStr = str.toLowerCase().split(" ");

//   for (let i = 0; i < splitStr.length; i++) {
//     splitStr[i] =
//       splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
//   }

//   return splitStr.join(" ");
// }

// function studentName(student) {
//   // titleCase(item.fname + ' ' + item.lname[0]) + '. (' + item.school + ')';
//   return escapeHtml(student.username + " (" + student.school + ")");
// }

// function schoolName(name) {
//   name = name.replace(/ School$/i, "");
// }

function displaySchoolLeaderboard(p) {
  let count = 1;
  let html = "";

  for (let item of school.sort((a, b) => b.score - a.score)) {
    html += `<tr>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${count}</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${item.name}</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;"><center>${item.score}</center></td>
			</tr>`;

    count++;
  }

  setTBodyInnerHTML(
    document.querySelector("#itp-school-leaderboard tbody"),
    html
  );

  return p;
}

function displayStudentLeaderboard(p) {
  let count = 1;
  let html = "";

  const subset = student
    .sort((a, b) => b.score - a.score)
    .slice(0, showMoreStudent ? student.length : 10);

  for (let item of subset) {
    //const name = titleCase(item.fname + ' ' + item.lname[0]) + '. (' + item.school + ')';

    // TODO fix this next line by adding school data
    //const name = studentName(item);

    html += `<tr>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${count}</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${item.name} ${
      item.school ? `(${item.school})` : ""
    }</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;"><center>${
        item.score
      }</center></td>
			</tr>`;

    count++;
  }

  setTBodyInnerHTML(
    document.querySelector("#itp-student-leaderboard tbody"),
    html
  );

  // create a button 'Sea More' and append to #itp-student-leaderboard'
  // when cllicked, showMoreStudent = true and displayStudentLeaderboard() is called again
  // to display all the students in the leaderboard
  if (!showMoreStudent) {
    const btnArea = document.createElement("div");
    btnArea.id = "itp-student-leaderboard-btn-area";
    btnArea.style =
      "display: flex; justify-content: center; align-items: center; padding: 20px; width: 100%;";

    const btn = document.createElement("button");
    btn.style =
      "background: rgba(0,0,0,0); border: 1px solid white; color: white; margin: auto; text-align:center;";
    btn.id = "show-more-student";
    btn.innerHTML = "See More";
    btn.onclick = function () {
      showMoreStudent = true;
      displayStudentLeaderboard();
    };

    btnArea.appendChild(btn);

    document
      .querySelector("#itp-student-leaderboard")
      .parentElement.appendChild(btnArea);
  } else {
    const btnArea = document.getElementById("itp-student-leaderboard-btn-area");
    btnArea.parentNode.removeChild(btnArea);
  }

  return p;
}

function displaySchoolStudentLeaderboard(p) {
  let count = 1;
  let html = "";

  console.log("schoolStudent data");
  console.log(schoolStudent);

  const subset = schoolStudent
    .sort((a, b) => b.score - a.score)
    .slice(0, showMoreMySchool ? schoolStudent.length : 10);

  for (let item of subset) {
    //const name = titleCase(item.fname + ' ' + item.lname[0]) + '. (' + item.school + ')';
    console.log("schoolStudent item with score: " + item.score);
    console.log(item);

    // TODO fix this next line by adding school data
    //const name = studentName(item);

    html += `<tr>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${count}</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${item.name}</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;"><center>${item.score}</center></td>
			</tr>`;

    count++;
  }

  setTBodyInnerHTML(
    document.querySelector("#itp-myschool-leaderboard tbody"),
    html
  );

  // create a button 'Sea More' and append to #itp-student-leaderboard'
  // when cllicked, showMoreStudent = true and displayStudentLeaderboard() is called again
  // to display all the students in the leaderboard
  if (!showMoreMySchool) {
    const btnArea = document.createElement("div");
    btnArea.id = "itp-myschool-leaderboard-btn-area";
    btnArea.style =
      "display: flex; justify-content: center; align-items: center; padding: 20px; width: 100%;";

    const btn = document.createElement("button");
    btn.style =
      "background: rgba(0,0,0,0); border: 1px solid white; color: white; margin: auto; text-align:center;";
    btn.id = "itp-myschool-leaderboard-btn";
    btn.innerHTML = "See More";
    btn.onclick = function () {
      showMoreMySchool = true;
      displaySchoolStudentLeaderboard();
    };

    btnArea.appendChild(btn);

    document
      .querySelector("#itp-myschool-leaderboard")
      .parentElement.appendChild(btnArea);
  } else {
    const btnArea = document.getElementById(
      "itp-myschool-leaderboard-btn-area"
    );
    btnArea.parentNode.removeChild(btnArea);
  }

  return p;
}

function displayTodayLeaderboard(p) {
  let count = 1;
  let html = "";

  const subset = today
    .sort((a, b) => b.score - a.score)
    .slice(0, showMoreToday ? today.length : 10);

  console.log("today data");
  console.log(subset);

  for (let item of subset) {
    //const name = titleCase(item.fname + ' ' + item.lname[0]) + '. (' + item.school + ')';

    // TODO fix this next line by adding school data
    //const name = studentName(item);

    html += `<tr>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${count}</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;">${item.name} ${
      item.school ? `(${item.school})` : ""
    }</td>
			<td style="border-bottom: dotted white 1px; border-right: 0px;"><center>${
        item.score
      }</center></td>
			</tr>`;

    count++;
  }

  setTBodyInnerHTML(
    document.querySelector("#itp-today-leaderboard tbody"),
    html
  );

  // create a button 'Sea More' and append to #itp-student-leaderboard'
  // when cllicked, showMoreStudent = true and displayStudentLeaderboard() is called again
  // to display all the students in the leaderboard
  if (!showMoreToday) {
    const btnArea = document.createElement("div");
    btnArea.id = "itp-today-leaderboard-btn-area";
    btnArea.style =
      "display: flex; justify-content: center; align-items: center; padding: 20px; width: 100%;";

    const btn = document.createElement("button");
    btn.style =
      "background: rgba(0,0,0,0); border: 1px solid white; color: white; margin: auto; text-align:center;";
    btn.id = "btnSeeMoreToday";
    btn.innerHTML = "See More";
    btn.onclick = function () {
      showMoreToday = true;
      displayTodayLeaderboard();
    };

    btnArea.appendChild(btn);

    document
      .querySelector("#itp-today-leaderboard")
      .parentElement.appendChild(btnArea);
  } else {
    const btnArea = document.getElementById("itp-today-leaderboard-btn-area");
    // remove btn from the DOM
    btnArea.parentNode.removeChild(btnArea);
  }

  return p;
}

function networkError(error) {
  alertify.error(
    "Network error! Will try to load leaderboard data again shortly."
  );
  console.error(error);
}

function loadStudentLeaderboard(resp) {
  if (typeof resp.entitiesList === "undefined") {
    return resp;
  }

  const success = resp.entitiesList.length > 0;

  if (success) {
    student = resp.entitiesList;
  }

  return resp;
}

function loadSchoolLeaderboard(resp) {
  if (typeof resp.entitiesList === "undefined") {
    return resp;
  }

  const success = resp.entitiesList.length > 0;

  if (success) {
    school = resp.entitiesList;
  }

  return resp;
}

function loadTodayLeaderboard(resp) {
  console.log("loadTodayLeaderboard");
  console.log(resp);
  if (typeof resp.entitiesList === "undefined") {
    return resp;
  }

  const success = resp.entitiesList.length > 0;

  if (success) {
    today = resp.entitiesList;
  }

  return resp;
}

function loadSchoolStudentLeaderboard(resp) {
  if (typeof resp.entitiesList === "undefined") {
    return resp;
  }

  const success = resp.entitiesList.length > 0;

  if (success) {
    schoolStudent = resp.entitiesList;
  }

  return resp;
}

export function leaderboard() {
  auth
    .ready()
    .then(() => {
      showSpinner();
      grpc.getTodayLeaderboard().then((r) => {
        displayTodayLeaderboard(loadTodayLeaderboard(r));
        todaylbFinished = true;
      });

      grpc.getSchoolLeaderboard().then((r) => {
        displaySchoolLeaderboard(loadSchoolLeaderboard(r));
        schoollbFinished = true;
      });

      grpc.getStudentLeaderboard().then((r) => {
        displayStudentLeaderboard(loadStudentLeaderboard(r));
        studentlbFinished = true;
      });

      grpc.getSchoolStudentLeaderboard().then((r) => {
        displaySchoolStudentLeaderboard(loadSchoolStudentLeaderboard(r));
        myschoollbFinished = true;
      });
    })
    .catch(networkError);

  // set an interval to check when the leaderboard data is loaded
  // then hide the spinner and cancel the interval
  const interval = setInterval(() => {
    if (
      studentlbFinished &&
      schoollbFinished &&
      todaylbFinished &&
      myschoollbFinished
    ) {
      hideSpinner();
      clearInterval(interval);
    }
  }, 200);
}

export default {};
